<template>
  <section id="promotions" class="relative z-10 py-24">
    <div class="relative mx-auto px-4 sm:max-w-4xl lg:max-w-6xl 2xl:max-w-7xl">
      <div class="flex flex-col items-center justify-center gap-2">
        <img
          v-motion-pop-visible
          class="max-w-[300px] object-contain"
          src="@/assets/hero-twinslots.png"
          alt="Twinslots word image"
        />
        <h2 v-motion-pop-visible class="mb-6 text-5xl font-normal text-white">PROMOTIONS</h2>
      </div>

      <!-- Promo Card -->
      <div
        class="relative z-20 min-w-[300px] overflow-hidden rounded-[50px] border-[6px] border-[#FFC125]/80 px-8 pt-4 pb-8 text-center shadow-[0_0_15px_5px_#FFC125]"
      >
        <img
          class="absolute inset-0 z-0 h-full w-full object-cover sm:hidden"
          src="@/assets/promo-card-mobile-bg.avif"
          alt="promo mobile background"
        />
        <img
          class="absolute inset-0 z-0 hidden h-full w-full object-cover sm:block"
          src="@/assets/promo-card-bg.avif"
          alt="promo background"
        />

        <!-- Content -->
        <div class="relative z-10 flex flex-col">
          <div class="flex w-full justify-between">
            <div
              v-motion-pop-visible
              class="mt-2 flex w-full flex-col items-center justify-center text-center leading-[100px] drop-shadow-[0px_10px_20px_#00F0FF4D] md:w-[400px] md:justify-start md:leading-[140px]"
            >
              <h2 class="text-[60px] text-white md:text-[80px]">USE CODE</h2>
              <h1 class="text-[160px] text-[#FFC125] md:text-[220px]">TWIN</h1>
              <!-- Mobile Button -->
              <a v-motion-pop-visible href="https://roobet.com/?ref=twin" class="mt-8 flex h-[70px] w-full md:hidden">
                <img
                  :src="require('@/assets/hero-button-mobile.png')"
                  alt="Register on Roobet.com button background"
                  class="absolute z-0 h-full w-full rounded-full object-contain transition-opacity duration-300"
                />
              </a>
            </div>
            <div class="flex flex-col justify-center pt-8 lg:flex-row lg:justify-between">
              <!-- Promo Call-to-Action -->
              <div class="relative ml-auto hidden w-[320px] flex-col items-center justify-end md:flex">
                <div v-motion-pop-visible class="flex flex-col items-center justify-center gap-4">
                  <p class="text-4xl text-white">SUPPORT US ON</p>
                  <img class="h-[60px]" src="@/assets/promo-roobet.png" alt="roobet" />
                </div>

                <button
                  v-motion-pop-visible
                  @mouseover="hoveredButton1 = true"
                  @mouseleave="hoveredButton1 = false"
                  class="relative mt-12 h-[82px] w-full max-w-[320px] overflow-hidden rounded-3xl font-bold transition-transform duration-300 hover:scale-105 hover:shadow-lg"
                >
                  <img
                    :src="
                      hoveredButton1
                        ? require('@/assets/hero-hover-cta-1.png')
                        : require('@/assets/hero-idle-cta-1.png')
                    "
                    alt="Register on Roobet.com button background"
                    class="absolute inset-0 z-0 h-full w-full object-cover transition-opacity duration-300"
                  />
                  <a
                    href="https://roobet.com/?ref=twin"
                    class="relative z-10 text-center font-lato text-lg font-bold text-[#19034C]"
                  >
                    Register on Roobet.com
                  </a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Roobet Rules -->
      <br />
      <br />
      <div v-motion-pop-visible class="font-inter text-base sm:text-lg text-white leading-relaxed bg-white/[0.06] p-6 sm:p-8 rounded-2xl border border-[#FFC125]/40 backdrop-blur-md shadow-[0_0_20px_rgba(255,193,37,0.15)]">
        <p class="font-bebas text-2xl sm:text-3xl text-[#FFC125] tracking-wide mb-3 drop-shadow-[0_0_8px_rgba(255,193,37,0.5)]">
          ROOBET LEADERBOARD WAGER RULES
        </p>
        <p class="font-bold text-white mb-3 text-sm sm:text-base md:text-lg">
          Leaderboard wager amounts may differ from your statistics on Roobet, depending on the games you are playing:
        </p>
        <ul class="space-y-2.5 pl-2 font-bold text-white text-sm sm:text-base md:text-lg">
          <li class="text-white">• Games with RTP of 97% or lower &rarr; <span class="text-[#FFC125] font-extrabold">100% of wager is counted</span></li>
          <li class="text-white">• Games with RTP between 97.01% and 98.99% &rarr; <span class="text-[#FFC125] font-extrabold">50% of wager is counted</span></li>
          <li class="text-white">• Games with RTP of 99% and over &rarr; <span class="text-[#FFC125] font-extrabold">10% of wager is counted</span></li>
          <li class="text-white">• Slots,  live casinos, housegames and dice count towards leaderboard.</li>
        </ul>
        <p class="mt-4 text-xs sm:text-sm md:text-base text-amber-200 font-semibold italic border-t border-white/10 pt-3">
          Any abuse found by TWIN or Roobet may result in your prize being forfeit.
        </p>
      </div>
    </div>

    <img
      v-motion-pop-visible
      class="absolute -right-6 bottom-0 z-0 w-[13%]"
      src="@/assets/promo-planet.png"
      alt="rocket"
    />
  </section>
</template>

<script>
import { ref } from 'vue';

export default {
  data() {
    return {
      promoList: [
        { wager: '$2,500', img: require('@/assets/promo-earn-10.png') },
        { wager: '$10,000', img: require('@/assets/promo-earn-25.png') },
        { wager: '$25,000', img: require('@/assets/promo-earn-50.png') },
        { wager: '$50,000', img: require('@/assets/promo-earn-100.png') },
        { wager: '$100,000', img: require('@/assets/promo-earn-200.png') },
      ],
      hoveredButton1: ref(false),
    };
  },
};
</script>
